<p-stepper [value]="currentStep" orientation="vertical" styleClass="vertical-stepper">
    <!-- Step 1: Push Notifications -->
    <p-step-item [value]="1">
        <p-step>Push Notifications</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <h3>Push Notifications</h3>
                <p>
                    AMMSAS needs your permission to send push notifications to keep you updated.
                    These notifications are essential for the application's functionality.
                </p>
                <div class="allow-access-button">
                    <p-button
                        label="Allow Notifications"
                        icon="pi pi-bell"
                        (click)="askPushPermission(activateCallback)"
                    />
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>

    <!-- Step 2: Camera -->
    <p-step-item [value]="2">
        <p-step>Camera</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <h3>Camera Permission</h3>
                <p>
                    AMMSAS uses the camera for scanning QR-Codes and uploading profile pictures.
                    We can't activate your camera without your interaction.
                </p>
                <div class="allow-access-button">
                    <p-button
                        label="Allow Camera Access"
                        icon="pi pi-camera"
                        (click)="askCameraPermission(activateCallback)"
                    />
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>

    <!-- Step 3: Microphone -->
    <p-step-item [value]="3">
        <p-step>Microphone</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <h3>Microphone Permission</h3>
                <p>
                    AMMSAS uses the microphone for its tuner and loudness meter features.
                    It won't activate or listen without your interaction.
                </p>
                <div class="allow-access-button">
                    <p-button
                        label="Allow Microphone Access"
                        icon="pi pi-microphone"
                        (click)="askMicrophonePermission(activateCallback)"
                    />
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>

    <!-- Step 4: Completion -->
    <p-step-item [value]="4">
        <p-step>Complete</p-step>
        <p-step-panel>
            <ng-template #content>
                <h3>Setup Complete</h3>
                <p>Thank you! AMMSAS is ready to go!</p>
                <div class="allow-access-button">
                    <p-button label="Finish Setup" icon="pi pi-check" (click)="completeSetup()" />
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>
</p-stepper>


<style>
    .allow-access-button{
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }
</style>